import { segmentLabelForChartTitle } from '../../PageConfigProvider/constants';
import type { SecondaryDimensionValues } from '../../PageConfigProvider/types/dimension';
import type {
  DimensionSource,
  PositionedItem,
} from '../../PageConfigProvider/types/item';

export const getSegmentForChartTitle = (
  item: PositionedItem | undefined,
  dimensionSourceOverrides: Record<string, DimensionSource> | undefined
): string | undefined => {
  const effectiveDimensionSource =
    (item?.id != null ? dimensionSourceOverrides?.[item.id] : undefined) ??
    item?.plot?.dimensionSource;

  if (
    !effectiveDimensionSource ||
    effectiveDimensionSource === 'primary' ||
    !(effectiveDimensionSource in segmentLabelForChartTitle)
  ) {
    return undefined;
  }
  return segmentLabelForChartTitle[
    effectiveDimensionSource as SecondaryDimensionValues
  ];
};
